import { onMounted, onUnmounted, ref } from 'vue';
import { infringementStatusEventsService } from '@/api/infringement-status-events.service';
import type { ServerSentEventService } from '@/api/server-sent-event.service';
import type { InfringementStatusEventDto } from '@carvia/ros-client-types';

export function useInfringementStatusEvents() {
  const events = ref<InfringementStatusEventDto[]>([]);
  const error = ref<Error | null>(null);
  const isConnected = ref(false);

  let subscription: { unsubscribe: () => void } | null = null;
  let service: ServerSentEventService<InfringementStatusEventDto> | null = null;

  onMounted(() => {
    service = infringementStatusEventsService();
    subscription = service.open().subscribe({
      next: (event) => {
        if (event) {
          events.value.push(event);
        }
      },
      error: (err) => {
        error.value = err;
        isConnected.value = false;
      },
      complete: () => {
        isConnected.value = false;
      },
    });
    isConnected.value = true;
  });

  onUnmounted(() => {
    if (subscription) {
      subscription.unsubscribe();
    }
    service?.close();
  });

  return {
    events,
    error,
    isConnected,
  };
}
